<template>
  <div class="assetCatalogue h-full">
    <div class="content h-full">
      <el-row :gutter="10" class="h-full">
        <el-col :span="5" id="leftCol" class="h-full">
          <el-card
            v-loading="loading"
            class="h-full"
            :body-style="{ padding: '20px', height: '100%', position: 'relative' }"
            id="assetCard"
          >
            <el-row class="mb-10px flex items-center text-14px">
              <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">{{
                $t('assetCatalogTree')
              }}</span>
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i
                    class="iconfont icon-line-moreVertical text-14px font-bold !text-[#606266]"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="operateTree(true)">{{
                    $t('expandAll')
                  }}</el-dropdown-item>
                  <el-dropdown-item @click.native="operateTree(false)">{{
                    $t('collapseThemAll')
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-row>
            <el-row>
              <el-select
                filterable
                clearable
                v-model="dataKind"
                class="!w-full"
                @change="getTreeKinds()"
              >
                <el-option
                  v-for="(item, index) in dataKindList"
                  :label="item.item2"
                  :value="item.item1"
                  :key="index"
                ></el-option>
              </el-select>
            </el-row>
            <el-row class="flex mt-10px">
              <el-input
                :placeholder="$t('pleaseEnter')"
                v-model="keyWord"
                clearable
                @keyup.enter.native="getTreeKinds()"
              ></el-input>
              <el-button type="primary" class="ml-10px" @click="getTreeKinds()">{{
                $t('search')
              }}</el-button>
            </el-row>
            <!-- <el-row class="flex mt-10px">
              <div class="flex-1 title text-14px font-bold">资产目录树</div>
            </el-row> -->
            <el-row class="h-[calc(100%-120px)] mt-10px" id="collectBox">
              <!-- 收藏树 -->
              <el-tree
                highlight-current
                :data="collectionTree"
                :props="collectionProps"
                ref="collectionTree"
                @node-click="handleCollectionClick"
                :default-expand-all="defaultExpandAll"
                node-key="treeId"
                v-if="treeStandBy && showCollection"
                class="max-h-1/2 overflow-auto"
              >
                <div class="custom-tree-node w-full flex flex-align-center" slot-scope="{ data }">
                  <el-tooltip :content="data.name" :open-delay="500" placement="top">
                    <span class="tree-text-label flex-1">{{ data.name }}</span>
                  </el-tooltip>
                  <el-tooltip :content="$t('unfavorite')" :open-delay="500" placement="top">
                    <span
                      v-if="data.treeId && $hasAccess('unbookmark')"
                      class="w-30px"
                      @click.stop="handleCommandTree(data.treeId, false, data.name)"
                      ><i class="iconfont icon-bg-collection"></i
                    ></span>
                  </el-tooltip>
                </div>
              </el-tree>
              <el-row style="overflow-y: auto" class="h-[calc(100%-120px)]" id="assetBox">
                <!-- 资产目录树 -->
                <el-tree
                  v-if="editableTabs.length && assetTree[0].children.length"
                  :data="assetTree"
                  :props="assetProps"
                  @node-click="handleAssetClick"
                  default-expand-all
                  ref="assetTree"
                  node-key="id"
                  class="h-full overflow-auto"
                >
                  <div
                    class="custom-tree-node text-overflow w-full flex flex-align-center"
                    slot-scope="{ data }"
                  >
                    <el-tooltip :content="data.name" :open-delay="500" placement="top">
                      <span class="text-overflow tree-text-label flex-1">{{ data.name }}</span>
                    </el-tooltip>
                    <el-tooltip :content="$t('collection')" :open-delay="500" placement="top">
                      <span
                        v-if="data.id && !data.isCollect && $hasAccess('collect')"
                        class="w-30px"
                        @click.stop="handleCommandTree(data.id, true, data.name)"
                        ><i class="iconfont icon-line-collection"></i
                      ></span>
                    </el-tooltip>
                  </div>
                </el-tree>
                <div v-else class="h-full flex-center text-[#909399] text-14px">
                  {{ $t('noDataYet') }}
                </div>
              </el-row>
            </el-row>
            <!-- <el-row
              v-if="showCollection"
              id="collectBox"
              style="max-height: 200px; overflow-y: auto"
              class="mt-10px"
            >
              <el-tree
                :data="collectionTree"
                :props="collectionProps"
                @node-click="handleCollectionClick"
                default-expand-all
                ref="collectionTree"
                node-key="treeId"
              >
                <div
                  class="custom-tree-node text-overflow w-full flex flex-align-center"
                  slot-scope="{ node, data }"
                >
                  <el-tooltip :content="data.name" :open-delay="500" placement="top">
                    <span class="text-overflow tree-text-label flex-1">{{ data.name }}</span>
                  </el-tooltip>
                  <el-tooltip content="取消收藏" :open-delay="500" placement="top">
                    <span
                      v-if="data.treeId && $hasAccess('unbookmark')"
                      class="w-30px"
                      @click.stop="handleCommandTree(data.treeId, false, data.name)"
                      ><i class="iconfont icon-bg-collection"></i
                    ></span>
                  </el-tooltip>
                </div>
              </el-tree>
            </el-row> -->
            <div class="toLeft" v-if="showLeft" @click="isShowLeft">
              <i class="iconfont icon-bg-circleLeft text-30px"></i>
            </div>
          </el-card>
        </el-col>
        <el-col :span="5" class="h-full">
          <el-card
            v-loading="treeLoading"
            class="h-full"
            :body-style="{ padding: '20px', height: 'calc(100% - 45px)', position: 'relative' }"
          >
            <div slot="header">
              <div class="text-center">{{ currentTreeName }}</div>
            </div>
            <div class="h-full w-full" id="tree">
              <VirtualTree
                :highlight-current="true"
                :data="treeData"
                :props="defaultProps"
                :treeStyle="{
                  maxHeight: heightObj.maxHeight,
                  minHeight: heightObj.minHeight,
                  overflowY: 'auto',
                }"
                class="w-full"
                emptyText="暂无数据"
                accordion
                @node-click="handleNodeClick"
                :expand-on-click-node="false"
                lazy
                :load="loadNode"
              >
                <div
                  class="custom-tree-node w-full d-flex flex-align-center"
                  slot-scope="{ node, data }"
                >
                  <el-tooltip :content="data.name" placement="top" :disabled="isShowTooltip">
                    <span
                      class="tree-text-config fz-12"
                      @mousemove="onMouseOver(`treeTooltip${node.id}`)"
                      :class="`treeTooltip${node.id}`"
                      >{{ data.name }}</span
                    >
                  </el-tooltip>
                </div>
              </VirtualTree>
            </div>
            <div class="toRight" v-if="!showLeft" @click="isShowLeft">
              <i class="iconfont icon-bg-circleRight text-30px"></i>
            </div>
          </el-card>
        </el-col>
        <el-col :span="14" id="rightCol" class="h-full">
          <div class="rightList h-full">
            <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
              <div type="flex" align="middle" class="w-full flex" ref="menuTop">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="classId"
                  :placeholder="$t('PleaseSelectACategory')"
                  class="w-200px mr-10px"
                >
                  <el-option
                    v-for="item in classIdList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="attrId"
                  :placeholder="$t('pleaseSelectAttr')"
                  class="w-200px mr-10px"
                  @change="changeAttr(attrId)"
                >
                  <el-option
                    v-for="item in attrList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="symbolValue"
                  v-if="selectedAttrType !== 11"
                  :placeholder="$t('请选择操作符')"
                  class="w-200px mr-10px"
                >
                  <el-option
                    v-for="item in symbolList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  class="w-200px mr-10px"
                  size="small"
                  v-model.trim="tableParams.keyword"
                  :placeholder="$t('请输入关键字')"
                  v-if="selectedAttrType === 1"
                  clearable
                ></el-input>
                <el-select
                  size="small"
                  clearable
                  v-if="selectedAttrType === 11"
                  filterable
                  v-model="tableParams.keyword"
                  :placeholder="$t('pleaseChoose')"
                  class="w-200px mr-10px"
                >
                  <el-option
                    v-for="item in labelArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
                <el-input-number
                  v-else-if="selectedAttrType === 2 || selectedAttrType === 3"
                  v-model.trim="tableParams.keyword"
                  :controls="false"
                  class="w-200px mr-10px"
                  :placeholder="$t('请输入关键字')"
                ></el-input-number>
                <el-time-picker
                  v-else-if="selectedAttrType === 9"
                  v-model.trim="tableParams.keyword"
                  class="w-200px mr-10px"
                  :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                  value-format="HH:mm:ss"
                  :placeholder="$t('selectTime')"
                ></el-time-picker>
                <el-date-picker
                  v-else-if="selectedAttrType === 8"
                  v-model.trim="tableParams.keyword"
                  class="w-200px mr-10px"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :placeholder="$t('selectDate')"
                ></el-date-picker>
                <el-date-picker
                  v-else-if="selectedAttrType === 6"
                  v-model.trim="tableParams.keyword"
                  class="w-200px mr-10px"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('SelectADatetime')"
                ></el-date-picker>
                <el-button type="primary" @click="initList('referch')">{{
                  $t('search')
                }}</el-button>
                <!-- <columnVisible
                  :options="columnVisibleOptions"
                  ref="columnVisible"
                  class="dib ml-10px"
                  :name="['assetCatalogueColumnVisible']"
                  :defaultValue="columnVisible"
                  @columnVisibleChanged="changeColumn"
                ></columnVisible> -->
              </div>
              <el-tabs
                style="height: calc(100% - 36px)"
                v-model="activeTab"
                v-loading="isTableLoading"
              >
                <el-tab-pane
                  :label="item.name"
                  :name="item.id"
                  class="h-full"
                  v-for="(item, index) in _.cloneDeep(tabList).splice(0, showItemNum)"
                  :key="index"
                >
                  <el-table
                    :data="tableData"
                    ref="table"
                    @row-dblclick="toDetail"
                    @sort-change="headerClick($event)"
                    border
                    height="calc(100% - 50px)"
                  >
                    <el-table-column
                      sortable
                      v-for="(val, index) in dynamicFilterHeader"
                      :prop="`${val.tableName}.${val.columnName}`"
                      :label="val.name"
                      :key="index"
                      min-width="180"
                      show-overflow-tooltip
                    >
                      <!-- <template slot="header">
                      <span>{{ val.name }}</span>
                      <i class="ml-10px el-icon-d-caret"></i>
                    </template> -->
                      <template slot-scope="scope">
                        <div
                          v-if="
                            scope.row[`${val.tableName}.${val.columnName}`] &&
                              typeof scope.row[`${val.tableName}.${val.columnName}`] === 'string' &&
                              scope.row[`${val.tableName}.${val.columnName}`].indexOf('.') !== -1 &&
                              [...imgExt, ...fileExt, 'pdf'].includes(
                                scope.row[`${val.tableName}.${val.columnName}`].substring(
                                  scope.row[`${val.tableName}.${val.columnName}`].lastIndexOf('.') +
                                    1
                                )
                              )
                          "
                        >
                          <span>{{ scope.row[`${val.tableName}.${val.columnName}`] }}</span>
                          <el-tooltip :content="$t('查看文件')" class="ml-10px">
                            <el-button
                              class="iconfont icon-line-show"
                              size="mini"
                              @click="viewFile(scope.row)"
                            ></el-button>
                          </el-tooltip>
                        </div>
                        <div v-else class="truncate">
                          {{ scope.row[`${val.tableName}.${val.columnName}`]
                          }}<span
                            v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]"
                            >{{ val.unit }}</span
                          >
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('operate')}`" width="100" fixed="right">
                      <template slot-scope="scope">
                        <el-button @click.stop="toDetail(scope.row)" size="mini">{{
                          $t('view')
                        }}</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="tableParams.pageno"
                    :page-sizes="$pageSizeAll"
                    :page-size.sync="tableParams.pagesize"
                    layout="->, total, sizes, prev, pager, next"
                    :total="pageTotal"
                    class="mt-20px"
                  ></el-pagination>
                </el-tab-pane>
                <el-tab-pane
                  :name="moreTab"
                  v-if="tabList.length > showItemNum"
                  class="h-full"
                  disabled
                >
                  <span slot="label">
                    <el-dropdown>
                      <div
                        class="
                          cursor-pointer
                          font-900
                          iconfont
                          icon-line-moreHorizontal
                          text-[#333]
                        "
                      ></div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          @click.native="clickTab(it)"
                          :class="{ 'text-active-dropdown': it.id === activeTab }"
                          v-for="(it, index) in _.cloneDeep(tabList).splice(
                            showItemNum,
                            tabList.length - 1
                          )"
                          :key="index"
                          >{{ it.name }}</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                  <el-table
                    :data="tableData"
                    ref="table"
                    @row-dblclick="toDetail"
                    @sort-change="headerClick($event)"
                    border
                    height="calc(100% - 50px)"
                  >
                    <el-table-column
                      sortable
                      v-for="(val, index) in dynamicFilterHeader"
                      :prop="`${val.tableName}.${val.columnName}`"
                      :label="val.name"
                      :key="index"
                      min-width="180"
                      show-overflow-tooltip
                    >
                      <!-- <template slot="header">
                      <span>{{ val.name }}</span>
                      <i class="ml-10px el-icon-d-caret"></i>
                    </template> -->
                      <template slot-scope="scope">
                        <div
                          v-if="
                            scope.row[`${val.tableName}.${val.columnName}`] &&
                              typeof scope.row[`${val.tableName}.${val.columnName}`] === 'string' &&
                              scope.row[`${val.tableName}.${val.columnName}`].indexOf('.') !== -1 &&
                              [...imgExt, ...fileExt, 'pdf'].includes(
                                scope.row[`${val.tableName}.${val.columnName}`].substring(
                                  scope.row[`${val.tableName}.${val.columnName}`].lastIndexOf('.') +
                                    1
                                )
                              )
                          "
                        >
                          <span>{{ scope.row[`${val.tableName}.${val.columnName}`] }}</span>
                          <el-tooltip :content="$t('查看文件')" class="ml-10px">
                            <el-button
                              class="iconfont icon-line-show"
                              size="mini"
                              @click="viewFile(scope.row)"
                            ></el-button>
                          </el-tooltip>
                        </div>
                        <div v-else class="truncate">
                          {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('operate')}`" width="100" fixed="right">
                      <template slot-scope="scope">
                        <el-button @click.stop="toDetail(scope.row)" size="mini">{{
                          $t('view')
                        }}</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="tableParams.pageno"
                    :page-sizes="$pageSizeAll"
                    :page-size.sync="tableParams.pagesize"
                    layout="->, total, sizes, prev, pager, next"
                    :total="pageTotal"
                    class="mt-20px"
                  ></el-pagination>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 查看文件 -->
    <el-dialog
      :width="uploadFileTitle === $t('upload') ? '400px' : '1200px'"
      :top="isFullScreen ? '0' : '15vh'"
      id="viewDialog"
      :title="uploadFileTitle"
      :visible.sync="uploadFileVisible"
      v-dialogDrag
    >
      <i
        @click="fullScreen()"
        v-show="uploadFileTitle !== $t('upload')"
        v-if="!isFullScreen"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        v-show="uploadFileTitle !== $t('upload')"
        @click="exitFullScreen()"
        v-else
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <div style="height: 520px" id="fileView" v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import assetService from '@/services/assetService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
// import ColumnVisible from '@/components/ColumnVisible'
import VirtualTree from '@/components/virtualScrollTree/tree'
import StandardManagementService from '@/services/common/StandardManagementService'

export default {
  components: {
    // ColumnVisible,
    VirtualTree,
  },
  computed: {
    bodyHeight() {
      return `${window.innerHeight - 150}px`
    },
    tableHeight() {
      return `${window.innerHeight - 270}px`
    },
  },
  data() {
    return {
      isShowTooltip: false,
      selectedAttrType: 1,
      symbolList: [],
      symbolValue: '',
      attrId: '', // 属性id
      classId: '', // 实体id
      attrList: [],
      labelArr: [],
      currentTreeId: '', // 当前选择的tabs的id
      treeData: [],
      editableTabs: [],
      treeLoading: false, // tree是否加载中
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'isLeaf',
      },
      input: '',
      activeName: 'first',
      tableData: [], // 表格数据
      isTableLoading: false,
      dynamicFilterHeader: [],
      dynamicHeader: [], // 动态表格字段集合
      columnVisibleOptions: [],
      columnVisible: [],
      showHeader: true, // 是否显示表头
      tableParams: {
        // 表格查询的参数
        keyword: '',
        breakdownnode: '',
        classattributeid: '',
        classattributecode: '',
        pageno: 1,
        pagesize: 15,
        breakDownId: '',
        whereConditions: '',
      },
      pageTotal: 0, // table总共条数
      sortableNum: 0,
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      uploadFileVisible: false,
      viewUrl: '',
      uploadFileTitle: '',
      isFullScreen: false,
      selectedId: '',
      browseItem: '',
      isImg: false,
      loadingFile: false,
      lastScrollHeight: 0,
      pageNo: 1,
      pageSize: 100,
      lastScrollTop: 0,
      loadTree: true,
      heightObj: {
        minHeight: '100%',
        maxHeight: '100%',
        isZoom: false,
      },
      currentTreeName: '',
      loading: false,
      keyWord: '',
      collectionTree: [
        {
          name: this.$t('favorites'),
          children: [],
        },
      ],
      collectionProps: {
        children: 'children',
        label: 'name',
      },
      assetTree: [
        {
          name: this.$t('assetCatalogTree'),
          children: [],
        },
      ],
      assetProps: {
        children: 'children',
        label: 'name',
      },
      showLeft: true,
      showCollection: true,
      assetBoxHeight: '200px',
      standardList: [],
      dataKindList: [],
      dataKind: 1, // 默认为业务数据
      defaultExpandAll: false, // 是否展开全部
      treeStandBy: true, // 是否显目录树 用于刷新树
      alarmIdList: [], // 绑定了报警的设备id集合
      classIdList: [], // 实体列表
      tabList: [
        // { name: '阀门', id: '1' },
        // { name: '冰箱', id: '2' },
        // { name: '管道', id: '3' },
        // { name: '水箱', id: '4' },
        // { name: '发电机', id: '5' },
        // { name: '泵功图', id: '6' },
        // { name: '变压器', id: '7' },
        // { name: '说明书11', id: '8' },
        // { name: '说明书22', id: '9' },
        // { name: '说明书33', id: '10' },
        // { name: '说明书44', id: '11' },
        // { name: '说明书55', id: '12' },
        // { name: '说明书66', id: '13' },
      ], // 实体tab
      activeTab: '', // 当前激活的tab
      totalHeader: {},
      totalData: {},
      totalCount: {},
      isSearch: true,
      currentObj: {},
      showItemNum: 7,
      moreTab: '0',
    }
  },
  async created() {
    await this.getSymbolList()
    await this.getDataKind()
    await this.getStandardList()
    await this.getCollection()
    this.getTreeKinds()
  },
  methods: {
    // 鼠标移入，文字长度溢出，显示tooltip
    onMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    clickTab(val) {
      this.moreTab = val.id
      this.activeTab = val.id
    },
    handleSizeChange(size) {
      this.tableParams.pagesize = size
      if (this.isSearch) {
        this.initList('referch')
      } else {
        this.getClassDataByTree('referch')
      }
    },
    handleCurrentChange(num) {
      this.tableParams.pageno = num
      if (this.isSearch) {
        this.initList('referch')
      } else {
        this.getClassDataByTree('refrech')
      }
    },
    // 获取实体列表
    async getClassList(standardId) {
      const parameter = {
        standard_id: standardId,
        pageno: 1,
        pagesize: 999,
        data_type: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classIdList = res.data
        if (this.classIdList.length > 0) {
          this.classId = this.classIdList[0].id
        }
      }
    },
    /**
     * @description: 操作区域树是否展开全部
     * @param {Boolean} bool
     * @return {*}
     */
    operateTree(bool) {
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },

    // 获取业务数据类型
    async getDataKind() {
      const res = await assetService.getDataKind()
      if (res && res.code === 0) {
        this.dataKindList = res.data
        _.map(this.dataKindList, (item) => {
          if (item.item2 === '业务数据') {
            this.dataKind = item.item1
          }
        })
      }
    },
    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
      }
    },
    // 列表转树结构（将标准id作为二级目录）
    listToTree(list) {
      const tree = []
      _.map(this.standardList, (item) => {
        _.map(list, (mItem) => {
          if (item.id === mItem.standardId) {
            const param = {
              name: item.name,
              children: [],
            }
            param.children.push(mItem)
            tree.unshift(param)
          }
        })
      })
      // 将相同标准库的数据放在一起
      let repeatIndex = []
      _.map(tree, (item, index) => {
        _.map(tree, (mItem, mIndex) => {
          if (item && mItem && item.name === mItem.name && index < mIndex) {
            const children = tree[index].children.concat(tree[mIndex].children)
            const map = new Map()
            const newArr = children.filter((v) => {
              return !map.has(v.id) && map.set(v.id, v)
            })
            tree[index].children = newArr
            repeatIndex.unshift(mIndex)
          }
        })
      })
      repeatIndex = [...new Set(repeatIndex)]
      _.map(repeatIndex, (index) => {
        tree.splice(index, 1)
      })
      return tree
    },
    handleCommandTree(id, val, name) {
      this.updateCollection(val, id, name)
    },
    isShowLeft() {
      this.showLeft = !this.showLeft
      if (this.showLeft) {
        document.getElementById('leftCol').className = 'el-col el-col-5 h-full'
        document.getElementById('rightCol').className = 'el-col el-col-14 h-full'
      } else {
        document.getElementById('leftCol').className = 'el-col el-col-0'
        document.getElementById('rightCol').className = 'el-col el-col-19 h-full'
      }
    },
    // 获取收藏夹内容
    async getCollection() {
      const res = await stdClassDataService.getCollection({ menu: 'asset-catalogue' })
      if (res) {
        this.collectionTree[0].children = res
      }
    },
    // 收藏自己的内容
    async updateCollection(val, id, name) {
      const res = await stdClassDataService.updateCollection({
        standardId: '',
        treeId: id,
        isFavorite: val,
        menu: 'asset-catalogue',
        name,
      })
      if (res && res.code === 0) {
        if (val) {
          this.$message.success(this.$t('collectionSuccess'))
        } else {
          this.$message.success(this.$t('cancelCollectionSuccess'))
        }
        _.map(this.assetTree[0].children, (item) => {
          _.map(item.children, (cItem) => {
            if (id === cItem.id) cItem.isCollect = val
            return cItem
          })
          return item
        })
        await this.getCollection()
        this.getTreeKinds()
      }
    },
    handleAssetClick(data) {
      // 清空资产tab的数据
      this.tableData = []
      this.dynamicHeader = []
      // 取消collectionTree的当前高亮节点
      this.$nextTick(() => {
        this.$refs.collectionTree.setCurrentKey(null)
      })
      if (data.id) {
        this.currentTreeName = data.name
        this.currentTreeId = data.id
      }
    },
    handleCollectionClick(data) {
      // 清空资产tab的数据
      this.tableData = []
      this.dynamicHeader = []
      // 取消assetTree的当前高亮节点
      if (this.editableTabs.length > 0) {
        this.$nextTick(() => {
          this.$refs.assetTree.setCurrentKey(null)
        })
      }
      if (data.treeId) {
        this.currentTreeName = data.name
        this.currentTreeId = data.treeId
      }
    },
    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    // 全屏
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('.el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
      }
    },
    // 查看文件
    async viewFile(row) {
      this.selectedId = row.id
      await this.getFileId(row.stdClassAttributeId)
      if (this.browseItem !== null) {
        $('#viewDialog .el-dialog').height(600)
        this.uploadFileTitle = this.$t('view')
        this.uploadFileVisible = true
        this.loadingFile = true
        // 2.通过fileId拿到返回的文件流
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('没有上传文件')
      }
    },
    changeColumn(data) {
      if (data.length === 0 && this.dynamicFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisible = data
      this.dynamicFilterHeader = _.filter(this.dynamicHeader, (item) => {
        return _.includes(data, item.code)
      })
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })
    },
    // 获取操作符
    async getSymbolList() {
      this.symbolList = []
      const res = await assetService.getSearchOperator()
      if (res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          this.symbolList.push({
            label: item.text,
            value: item.value,
          })
        })
        if (this.symbolList.length) {
          this.symbolValue = this.symbolList[0].value
        }
      }
    },
    async getAttrList(classId) {
      const parameter = {
        classId,
        maxResultCount: 999,
        nameOrCode: '',
        skipCount: 0,
        sorting: '',
      }
      const res = await assetService.getClassAndClassTypeAttrDropDowData(parameter)
      if (res && res.code === 0 && res.data) {
        this.attrList = res.data
        if (res.data.length > 0) {
          this.attrId = res.data[0].id
        }
      }
    },
    async changeAttr(value) {
      if (!value) {
        return
      }
      this.tableParams.keyword = undefined
      // this.attrList.forEach((item) => {
      //   if (item.columnName === value) {
      //     this.selectedAttrType = item.valueType
      //   }
      // })
      // if (this.selectedAttrType === 11) {
      //   const parameter = {
      //     classId: this.classId,
      //   }
      //   const res = await stdClassDataService.getTagAttrList(parameter)
      //   if (res && res.code === 0 && res.data) {
      //     this.labelArr = res.data
      //   }
      // }
    },
    headerClick(event) {
      this.tableParams.orderBy = event.prop
      if (this.sortableNum === 0) {
        this.tableParams.orderByType = this.sortableNum
        this.sortableNum = 1
      } else {
        this.tableParams.orderByType = this.sortableNum
        this.sortableNum = 0
      }
      this.initList()
    },
    async loadNode(node, resolve) {
      if (node.level > 0) {
        const res = await assetService.getLazyTreeDatas(node.data.object)
        if (res && res.code === 0 && res.data) {
          return resolve(res.data)
        }
        return resolve([])
      }
      return resolve([])
    },
    // 获取资产列表（ 通过目录树获,取实体数据 ）
    async getClassDataByTree(type) {
      this.isTableLoading = true
      if (type === 'referch') {
        this.tableParams.pageno = 1
      }
      const res = await assetService.getClassDataByTree({
        skipCount: (this.tableParams.pageno - 1) * this.tableParams.pagesize,
        maxResultCount: this.tableParams.pagesize,
        sorting: '',
        object: this.currentObj,
      })
      this.isTableLoading = false
      if (res && res.code === 0 && res.data) {
        this.totalHeader = res.data.classDataHeader
        this.totalData = res.data.classData
        this.totalCount = res.data.classDataCount
        this.tabList = res.data.stdClassList
        this.activeTab = this.tabList.length > 0 ? this.tabList[0].id : ''
        if (this.activeTab) {
          this.tableData = this.totalData[this.activeTab]
          this.dynamicFilterHeader = this.totalHeader[this.activeTab]
          this.pageTotal = this.totalCount[this.activeTab]
        }
      }
    },
    // 初始化列表数据（根据操作符获取实体和实体类型 的动态数据）
    async initList(type) {
      this.isSearch = true
      if (type === 'referch') {
        this.tableParams.pageno = 1
      }
      if (!this.classId) {
        this.$message({
          message: this.$t('PleaseSelectACategory'),
          type: 'warning',
        })
        return
      }
      if (!this.attrId) {
        this.$message({
          message: this.$t('pleaseSelectAttr'),
          type: 'warning',
        })
        return
      }
      if (this.symbolValue === '' || this.symbolValue === null) {
        this.$message({
          message: this.$t('请选择操作符'),
          type: 'warning',
        })
        return
      }
      // this.tableParams.searchCode = this.attrId
      // this.tableParams.operator = this.symbolValue ? this.symbolValue : 0
      // this.tableParams.breakDownId = this.currentTreeId
      // console.log(111, this.tableParams)
      this.isTableLoading = true
      const res = await assetService.getTreeList({
        skipCount: (this.tableParams.pageno - 1) * this.tableParams.pagesize,
        maxResultCount: this.tableParams.pagesize,
        sorting: '',
        classAttributeId: this.attrId,
        operator: this.symbolValue,
        keywords: this.tableParams.keyword,
      })
      this.isTableLoading = false
      if (res && res.code === 0 && res.data) {
        this.totalHeader = res.data.classDataHeader
        this.totalData = res.data.classData
        this.totalCount = res.data.classDataCount
        this.tabList = res.data.stdClassList
        this.activeTab = this.tabList.length > 0 ? this.tabList[0].id : ''
        if (this.activeTab) {
          this.tableData = this.totalData[this.activeTab]
          this.dynamicFilterHeader = this.totalHeader[this.activeTab]
          this.pageTotal = this.totalCount[this.activeTab]
        }
        // this.tableData = res.data.dynamicData
        // this.dynamicHeader = res.data.headers
        // this.columnVisible = res.data.headers.map((item) => {
        //   return item.code
        // })
        // this.dynamicHeader.forEach((item) => {
        //   this.$set(item, 'label', item.name)
        //   this.$set(item, 'value', item.code)
        // })
        // this.columnVisibleOptions = this.dynamicHeader
        // if (this.$refs.columnVisible) {
        //   this.$refs.columnVisible.columnVisible = this.columnVisible
        // }
        // this.changeColumn(this.columnVisible)
      }
    },
    // tree点击操作
    handleNodeClick(data) {
      // 递归获取想要的数据
      // const newObj = {
      //   classattributeid: [],
      //   classattributecode: [],
      //   breakdownnode: [],
      // }
      // this.getFilterData(node, newObj)
      // _.forIn(newObj, (val, key) => {
      //   newObj[key] = _.join(val, ',')
      // })
      // _.assign(this.tableParams, newObj, {
      //   breakDownId: data.breakDownId,
      //   whereConditions: data.whereConditions,
      // })
      // this.tableParams.orderBy = data.classAttributeCode
      // this.initList('referch')
      this.isSearch = false
      this.currentObj = data.object
      this.getClassDataByTree('referch')
    },
    // 递归循环tree节点获取想要的数据
    getFilterData(node, newObj) {
      newObj.classattributeid.push(node.data.classAttributeId)
      newObj.classattributecode.push(node.data.classAttributeCode)
      newObj.breakdownnode.push(node.data.breakDownNode)
      if (node.level === 1) {
        return false
      }
      this.getFilterData(node.parent, newObj)
    },
    // 获取资产目录树种类集合
    async getTreeKinds() {
      // const assetCard = document.getElementById('assetCard').offsetHeight
      if (this.keyWord === '' || this.keyWord === null) {
        this.showCollection = true
        // const collectBox = document.getElementById('collectBox')
        //   ? document.getElementById('collectBox').offsetHeight
        //   : 0
        // this.assetBoxHeight = `${assetCard - collectBox - 146}px`
      } else {
        this.showCollection = false
        // this.assetBoxHeight = `${assetCard - 146}px`
      }
      this.loading = true
      const params = { flag: 0, data_kind: this.dataKind }
      params['name[$text]'] = this.keyWord
      const res = await assetService.getTreeKinds(params)
      this.loading = false
      if (res && res.code === 0 && res.data.length) {
        const displayStandardNames = res.data.filter((item) => {
          return item.isDisplayStandardName
        })
        if (displayStandardNames.length) {
          this.editableTabs = this.listToTree(res.data)
        } else {
          this.editableTabs = res.data
        }
        this.editableTabs = _.map(this.editableTabs, (item) => {
          _.map(item.children, (cItem) => {
            if (_.find(this.collectionTree[0].children, ['treeId', cItem.id])) {
              cItem.isCollect = true
            } else {
              cItem.isCollect = false
            }
            return cItem
          })
          return item
        })
        this.assetTree[0].children = this.editableTabs
        this.currentTreeId =
          this.$route.query.currentTreeId ||
          this.editableTabs[0].id ||
          this.editableTabs[0].children[0].id
        this.currentTreeName =
          this.$route.query.currentTreeName ||
          this.editableTabs[0].name ||
          this.editableTabs[0].children[0].name
        this.$nextTick(() => {
          this.$refs.assetTree.setCurrentKey(this.currentTreeId)
        })
        // this.classId = res.data[0].classId
        // if (!_.isEmpty(res.data)) {
        //   await this.getAttrList(res.data[0].classId)
        //   this.getTreeData()
        // }
      } else {
        this.editableTabs = []
        this.assetTree[0].children = this.editableTabs
        this.currentTreeId = '0'
        this.currentTreeName = ''
        this.treeData = []
        this.tableData = []
      }
    },
    // 根据id获取tree数据
    async getTreeData() {
      const treeHeigh = document.getElementById('tree').offsetHeight
      if (treeHeigh > 0) {
        this.heightObj.maxHeight = `${treeHeigh / 16}rem`
      }
      this.treeLoading = true
      const params = {
        structureBreakdownId: this.currentTreeId,
        skipCount: this.pageNo - 1,
        maxResultCount: this.pageSize,
        sorting: '',
      }
      const resTree = await assetService.getFirstTreeById(params)
      if (resTree && resTree.code === 0 && resTree.data) {
        // withhierarchy = 1 不请求下一级菜单
        this.treeData = resTree.data
        // this.treeData = _.map(resTree.data, (item) => {
        //   item.isLeaf = item.withhierarchy === 1
        //   return item
        // })
        this.treeLoading = false
        this.tableParams.classattributeid = []
        this.tableParams.classattributecode = []
        this.tableParams.breakdownnode = []
        this.tableParams.breakDownId = ''
        this.tableParams.whereConditions = ''
        // 初始化时根据树形列表的第一项的classAttributeCode 查询资产列表
        if (this.pageNo === 1 && resTree.totalCount > 100) {
          const res = await assetService.getFirstTreeById({
            id: this.currentTreeId,
            PageNo: 1,
            PageSize: resTree.totalCount,
          })
          if (res && res.code === 0 && res.data) {
            this.treeData = res.data
            // this.treeData = _.map(res.data, (item) => {
            //   item.isLeaf = item.withhierarchy === 1
            //   return item
            // })
          }
        }
        if (resTree.data.length) {
          this.tableParams.orderBy = resTree.data[0].classAttributeCode
        }
        return
      }
      this.treeLoading = false
    },
    // 查看详情页面
    toDetail(val) {
      this.$router.push({
        path: './asset-view',
        query: {
          id: val.id,
          classId: this.activeTab,
          currentTreeId: this.currentTreeId,
          currentTreeName: this.currentTreeName,
          pageType: 'assetView',
        },
      })
    },
  },
  watch: {
    async currentTreeId(val) {
      if (val !== '0') {
        this.getTreeData()
        // 切换tab改变选择属性
        if (this.editableTabs.length > 0) {
          _.map(this.editableTabs, async (item) => {
            const currentTabRow = _.find(item.children, ['id', val])
            if (!_.isEmpty(currentTabRow)) {
              await this.getClassList(currentTabRow.standardId)
              await this.getAttrList(this.classId)
              // this.initList('referch')
              this.tabList = []
              this.tableData = []
              this.dynamicFilterHeader = []
              this.pageTotal = 0
            }
          })
        }
      }
    },
    attrId(val) {
      if (!val) {
        this.symbolValue = ''
        this.tableParams.keyword = ''
      } else {
        this.tableParams.classattributeid = []
        this.tableParams.classattributecode = []
        this.tableParams.breakdownnode = []
        this.tableParams.breakDownId = ''
        this.tableParams.whereConditions = ''
      }
    },
    classId(val) {
      if (val) {
        this.getAttrList(val)
      }
    },
    activeTab(val) {
      if (val) {
        this.tableData = this.totalData[val]
        this.dynamicFilterHeader = this.totalHeader[val]
        this.pageTotal = this.totalCount[val]
      }
    },
    tabList: {
      handler(newVal) {
        if (this.$refs.menuTop && this.$refs.menuTop.clientWidth) {
          let totalLength = 0
          let flag = false
          const clientWidth = this.$refs.menuTop.clientWidth
          _.map(newVal, (item, index) => {
            if (index === 0) {
              totalLength = 14 * item.name.length + 20 + totalLength
            } else {
              totalLength = 14 * item.name.length + 20 * 2 + totalLength
            }
            if (totalLength <= clientWidth) {
              this.showItemNum = newVal.length
            }
            if (totalLength > clientWidth && !flag) {
              this.showItemNum = index + 1
              flag = true
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.icon-line-fullscreen,
.icon-pc_merge {
  top: 23px;
  right: 45px;
}
.content {
  // display: flex;
  // flex-direction: row;
  .leftTree {
    width: 20%;
    // /deep/.el-tabs__content {
    //   height: 95% !important;
    //   overflow: auto !important;
    //   /deep/.el-tree {
    //     .el-tree-node {
    //       .el-tree-node__loading-icon {
    //         display: none !important;
    //       }
    //       .el-tree-node__children {
    //         overflow: inherit !important;
    //       }
    //     }
    //   }
    // }
    /deep/.el-tabs__nav-next,
    /deep/.el-tabs__nav-prev {
      line-height: 34px !important;
      font-size: 20px;
      color: #1682e6;
    }
  }
  .rightList {
    box-sizing: border-box;
    /deep/.el-table tr {
      cursor: pointer !important;
    }
    /deep/.el-table__body-wrapper {
      height: 65vh;
      overflow-y: auto;
    }
    /deep/ .el-tabs .el-tabs__content {
      height: calc(100% - 55px);
    }
  }
}
.multipane-resizer:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  width: 6px;
  height: 45px;
  border-left: 2px solid #d2d2d2;
  border-right: 2px solid #d2d2d2;
  transform: translate(-50%, -50%);
}

.multipane-resizer:hover:before {
  border-color: #999;
}
// /deep/.el-input__inner {
//   height: 32px !important;
// }
// /deep/.el-input__icon {
//   line-height: 32px;
// }
.position-absolute {
  position: absolute;
}
/deep/.el-card__header {
  padding: 10px !important;
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon-bg-circleLeft:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
.icon-line-collection:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-collection:before {
  color: var(--buttonPrimaryBg);
}
.toLeft {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toRight {
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-input-number .el-input__inner {
  text-align: left;
}

</style>
